/* unplugin-vue-components disabled */import { render } from "./PlaneTurntableRender.vue?vue&type=template&id=57ca8773&scoped=true"
import script from "./PlaneTurntableRender.vue?vue&type=script&lang=js"
export * from "./PlaneTurntableRender.vue?vue&type=script&lang=js"

import "./PlaneTurntableRender.vue?vue&type=style&index=0&id=57ca8773&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57ca8773"]])

export default __exports__